import { render } from "./ThePatientDocumentShowModal.vue?vue&type=template&id=9738df54&ts=true"
import script from "./ThePatientDocumentShowModal.vue?vue&type=script&lang=ts"
export * from "./ThePatientDocumentShowModal.vue?vue&type=script&lang=ts"

import "./ThePatientDocumentShowModal.vue?vue&type=style&index=0&id=9738df54&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__